var _circle, _ellipse, _path, _path2, _path3, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWindSpeed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3.67443,
    cy: 9.00951,
    r: 3.46154,
    fill: "#1E2447"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.3242,
    cy: 6.66964,
    rx: 3.46154,
    ry: 3.46154,
    transform: "rotate(-1 20.3242 6.66964)",
    fill: "#1E2447"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.18458 9.07836L18.4962 6.92646L3.18458 9.07836Z",
    fill: "#1E2447"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.18458 9.07836L18.4962 6.92646",
    stroke: "#1E2447",
    strokeWidth: 1.73077
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9995 5.36707C13.0482 5.36707 13.9064 6.18323 13.9733 7.21503L13.9775 7.34509V11.3011H10.0215V7.34509L10.0257 7.21503C10.0927 6.18323 10.9508 5.36707 11.9995 5.36707Z",
    fill: "#1E2447"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.0117,
    y: 11.3011,
    width: 1.97802,
    height: 9.89011,
    fill: "#1E2447"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindSpeed);
export default __webpack_public_path__ + "static/media/WindSpeed.19dd979b.svg";
export { ForwardRef as ReactComponent };